module.exports = __webpack_public_path__ + "static/backdrop-841fe589eddeabab5af86df40e599b12.jpg";